/* tslint:disable */
/* eslint-disable */
/**
 * Guarantees API
 * Référentiel des garanties, rattachées aux branches
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Recherche paginée dans le référentiel des garanties.
 * @export
 * @interface SearchGarantiesReferentielCommand
 */
export interface SearchGarantiesReferentielCommand {
    /**
     * 
     * @type {string}
     * @memberof SearchGarantiesReferentielCommand
     */
    branchId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchGarantiesReferentielCommand
     */
    searchString?: string | null;
    /**
     * Ne remonte que les garanties sans branche. La reprise de données en a laissé un certain nombre : sans un filtre exposé à l'écran, elles restent invisibles.
     * @type {boolean}
     * @memberof SearchGarantiesReferentielCommand
     */
    unassignedOnly?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SearchGarantiesReferentielCommand
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchGarantiesReferentielCommand
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the SearchGarantiesReferentielCommand interface.
 */
export function instanceOfSearchGarantiesReferentielCommand(value: object): value is SearchGarantiesReferentielCommand {
    return true;
}

export function SearchGarantiesReferentielCommandFromJSON(json: any): SearchGarantiesReferentielCommand {
    return SearchGarantiesReferentielCommandFromJSONTyped(json, false);
}

export function SearchGarantiesReferentielCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchGarantiesReferentielCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'searchString': json['searchString'] == null ? undefined : json['searchString'],
        'unassignedOnly': json['unassignedOnly'] == null ? undefined : json['unassignedOnly'],
        'pageNumber': json['pageNumber'] == null ? undefined : json['pageNumber'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function SearchGarantiesReferentielCommandToJSON(json: any): SearchGarantiesReferentielCommand {
    return SearchGarantiesReferentielCommandToJSONTyped(json, false);
}

export function SearchGarantiesReferentielCommandToJSONTyped(value?: SearchGarantiesReferentielCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branchId': value['branchId'],
        'searchString': value['searchString'],
        'unassignedOnly': value['unassignedOnly'],
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
    };
}

